"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnswerPath = void 0;
exports.isReferencePath = isReferencePath;
const apiUtils_1 = require("../utils/apiUtils");
function isReferencePath(path) {
    return !!path.fromValueAt;
}
class AnswerPath {
    path;
    nodeId;
    isCollection;
    parent;
    constructor({ path, nodeId = undefined, parent = undefined, isCollection = false, }) {
        this.path = path;
        this.nodeId = nodeId;
        this.isCollection = isCollection;
        this.parent = parent;
    }
    /** Count collection AnswerPath's in [parent, grandparent, ...] */
    static getAncestorCollectionCount(answerPath) {
        let currentAnswerPath = answerPath?.parent;
        let ancestorCollectionCount = 0;
        while (currentAnswerPath) {
            if (currentAnswerPath.isCollection) {
                ancestorCollectionCount += 1;
            }
            currentAnswerPath = currentAnswerPath.parent;
        }
        return ancestorCollectionCount;
    }
    static toIdentifiableString(answerPath, divider = '.') {
        let str = isReferencePath(answerPath.path) ? `<${answerPath.path.fromValueAt}>` : answerPath.path;
        if (answerPath.parent) {
            const parentString = AnswerPath.toIdentifiableString(answerPath.parent, divider);
            str = `${parentString}${divider}${str}`;
        }
        return str;
    }
    static getAncestorCollectionAnswerPath(answerPath) {
        if (!answerPath.parent) {
            return null;
        }
        else if (answerPath.parent.isCollection) {
            return answerPath.parent;
        }
        // Has a parent but parent is not a collection, continue search up the tree.
        return this.getAncestorCollectionAnswerPath(answerPath.parent);
    }
    // To find the nodeId of a given collection answer path,
    // we can match against the JSON path described by the tree.
    static getIdentifiableStringToCollectionNodeIdMap(nodeIdToAnswerPath) {
        return nodeIdToAnswerPath.reduce((idStringToNodeId, [nodeId, answerPath]) => {
            if (answerPath.isCollection) {
                const identifiableString = AnswerPath.toIdentifiableString(answerPath);
                idStringToNodeId[identifiableString] = nodeId;
            }
            return idStringToNodeId;
        }, {});
    }
    static getCollectionNodeId(answerPath, nodeIdAnswerPathMap) {
        const serializedNodeIdToAnswerPathMap = (0, apiUtils_1.serializeNodeIdToAnswerPathMap)(nodeIdAnswerPathMap);
        const collectionNodeIdMap = this.getIdentifiableStringToCollectionNodeIdMap(serializedNodeIdToAnswerPathMap);
        const collectionIdentifiableString = this.toIdentifiableString(answerPath);
        return collectionNodeIdMap[collectionIdentifiableString];
    }
}
exports.AnswerPath = AnswerPath;
